var _slicedToArray = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _createForOfIteratorHelper = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
var _classCallCheck = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var OrangeChartAbstractGrid = require('./orange-chart-abstract-grid');
var _require = require('orange-svg'),
  OrangeSVGCircle = _require.OrangeSVGCircle,
  OrangeSVGPolyline = _require.OrangeSVGPolyline;
var OrangeChartDots = /*#__PURE__*/function (_OrangeChartAbstractG) {
  "use strict";

  _inherits(OrangeChartDots, _OrangeChartAbstractG);
  var _super = _createSuper(OrangeChartDots);
  function OrangeChartDots() {
    _classCallCheck(this, OrangeChartDots);
    return _super.apply(this, arguments);
  }
  _createClass(OrangeChartDots, [{
    key: "_do_render_elements",
    value:
    /**
     *
     * @param {OrangeSVG} svg
     * @param {[number, number, number][]} data
     * @param {string|function} color
     * @param {string} property
     * @param {object} view
     * @param _
     * @protected
     */
    function _do_render_elements(svg, data, color, property, view, _) {
      if (view.median_line) {
        this._do_render_median_line(svg, data, view.median_line, view.median_line_color || '#808080');
      }
      if (view.average_line) {
        this._do_render_average_line(svg, data, view.average_line, view.average_line_color || '#808080');
      }
      var callbacks = this.getCallbacks(property);
      var i = 0;
      var _iterator = _createForOfIteratorHelper(data),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 4),
            x = _step$value[0],
            y = _step$value[1],
            radius = _step$value[2],
            row = _step$value[3];
          var circle = new OrangeSVGCircle(x, y, radius, typeof color === 'function' ? color(row) : color);
          circle.args = {
            'data-property': property || '',
            'class': 'orange-chart-dots-dot'
          };
          svg.appendChild(circle, callbacks, {
            property: property,
            row: row,
            'value': {
              'x': this._data[i][this._axes['x'].source],
              'y': this._data[i][property]
            }
          });
          ++i;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * Returns data 
     * @param {[number, number, number][]} data
     * @param {number} chunks_number Number of chunks
     */
  }, {
    key: "_get_data_chunks",
    value: function _get_data_chunks(data, chunks_number) {
      var groups = [];
      var elements_by_group = data.length / chunks_number;
      for (var i = 0; i < data.length; i++) {
        var gn = Math.floor(i / elements_by_group);
        if (!groups[gn]) {
          groups[gn] = [];
        }
        groups[gn].push(data[i]);
      }
      return groups;
    }

    /**
     * Renders median line
     * @param {OrangeSVG} svg
     * @param {[number, number, number][]} data
     * @param {number} line_chunks Number of median line's points 
     * @param {string} line_color 
     */
  }, {
    key: "_do_render_median_line",
    value: function _do_render_median_line(svg, data, line_chunks, line_color) {
      var xy = data.sort(function (a, b) {
        return a[0] - b[0];
      }).map(function (v) {
        return {
          x: v[0],
          y: v[1]
        };
      });
      var groups = this._get_data_chunks(xy, line_chunks);
      var points = [];
      var _iterator2 = _createForOfIteratorHelper(groups),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var group = _step2.value;
          var median_i = (group.length - 1) / 2;
          var x = (group[Math.floor(median_i)].x + group[Math.ceil(median_i)].x) / 2;
          var group_y = group.sort(function (a, b) {
            return a.y - b.y;
          });
          var y = (group_y[Math.floor(median_i)].y + group_y[Math.ceil(median_i)].y) / 2;
          points.push([x, y]);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var line = new OrangeSVGPolyline(points, line_color);
      line.args = {
        'class': "orange-chart-median"
      };
      svg.appendChild(line);
    }

    /**
     * Renders average line
     * @param {OrangeSVG} svg
     * @param {[number, number, number][]} data
     * @param {number} line_chunks Number of median line's points 
     * @param {string} line_color 
     */
  }, {
    key: "_do_render_average_line",
    value: function _do_render_average_line(svg, data, line_chunks, line_color) {
      var xy = data.sort(function (a, b) {
        return a[0] - b[0];
      }).map(function (v) {
        return {
          x: v[0],
          y: v[1]
        };
      });
      var groups = this._get_data_chunks(xy, line_chunks);
      var points = [];
      var _iterator3 = _createForOfIteratorHelper(groups),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var group = _step3.value;
          var x = group.reduce(function (a, c) {
            return a + c.x;
          }, 0) / group.length;
          var y = group.reduce(function (a, c) {
            return a + c.y;
          }, 0) / group.length;
          points.push([x, y]);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var line = new OrangeSVGPolyline(points, line_color);
      line.args = {
        'class': "orange-chart-average"
      };
      svg.appendChild(line);
    }
  }], [{
    key: "allowed_axes",
    get:
    /**
     * Returns allowed axes for the chart
     *
     * @type {string[]}
     * @static
     */
    function get() {
      return ['x', 'y', 'z'];
    }
  }]);
  return OrangeChartDots;
}(OrangeChartAbstractGrid);
module.exports = OrangeChartDots;